import {
  BucketAwtENUM,
  ESTADO_VALIDACION_PREVENTA_CHOICE,
  EstadoPreventaEnum,
  EstadoValidacionPreventaEnum,
  gridSizeMdLg12,
  gridSizeMdLg6,
  handleAxiosError,
} from "@/shared";
import { useGetPreventas, useUpdatePreventa } from "@/shared/actions/erp";
import {
  CustomSearch,
  CustomTextFieldNoForm,
  TabTextLabel,
} from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import ImageUploadComponente from "@/shared/components/ui/UploadImage/ImageUploadComponente";
import { useTableFilter, useUploadFile } from "@/shared/hooks";
import { useTableColumnsPreventa } from "@/shared/hooks/useTableColumnsPreventa";
import { AlertSeverityEnum, IDataPreventa } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { Grid, TextField, Typography } from "@mui/material";
import { useState } from "react";

export default function PreventaActualizarIAPage() {
  //STATE
  const [imgIdentificacion, setImgIdentificacion] = useState<File | null>(null);
  const [codigoDactilar, setCodigoDactilar] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [dataPreventa, setDataPreventa] = useState<IDataPreventa | null>(null);

  //STORE
  const setAlert = useUiStore((s) => s.setAlert);

  //HOOK PERSONALIZADO
  const { columnsPendienteActualizarIA } = useTableColumnsPreventa(
    EstadoPreventaEnum.EN_ESPERA
  );

  const {
    globalFilter,
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,
  } = useTableFilter();

  const { handleUpdateFile } = useUploadFile();

  const { pageIndex, pageSize } = pagination;

  const {
    isLoading,
    data: preventasRes,
    isRefetching,
  } = useGetPreventas({
    estado_validacion_in: ESTADO_VALIDACION_PREVENTA_CHOICE.map(
      (code) => `${code}`
    ).join(","),
    identificacion: searchTerm,
    revisar_contrato: true,
    page: pageIndex + 1,
    page_size: pageSize,
    fecha_preventa_before: dateBefore,
    fecha_preventa_after: dateAfter,
  });

  //FETCH
  const { mutateAsync: mutateAsyncPreventa } = useUpdatePreventa();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomSearch
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificacion"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}
          />
        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IDataPreventa>
            columns={columnsPendienteActualizarIA}
            data={preventasRes?.data.data || []}
            isLoading={isLoading}
            isRefetching={isRefetching}
            enableGlobalFilter={false}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={preventasRes?.data?.count}
            actionsColumnSize={120}
            canDelete={false}
            positionActionsColumn="first"
            toolTipTitleEditIcon="Acción"
            onEdit={(e) => {
              try {
                if (e.errores && e.errores.length > 0) {
                  setDataPreventa(e);
                  setOpenModal(true);
                  return;
                }
                setAlert(
                  true,
                  "No se encontraton errores en el estado de validación",
                  AlertSeverityEnum.warning
                );
              } catch (error) {
                handleAxiosError(error);
              }
            }}
            canEdit={true}
            enableEditing={true}
          />
        </Grid>
      </Grid>

      <ScrollableDialogProps
        confirmTextBtn="Actualizar"
        onCloseIcon={() => {
          setOpenModal(false);
          setImgIdentificacion(null);
        }}
        open={openModal}
        dialogContentText={
          "Se presentaron las siguientes advertencia al firmar el contrato"
        }
        title="Actualizar Documentos"
        minWidth="50%"
        onConfirm={async () => {
          try {
            if (
              !imgIdentificacion &&
              dataPreventa?.errores.find(
                (e) =>
                  e === EstadoValidacionPreventaEnum.FOTO_CEDULA_TRASERA_BORROSA
              )
            )
              return setAlert(
                true,
                "Subir imagen de cedula trasera",
                AlertSeverityEnum.warning
              );

            if (
              !codigoDactilar &&
              dataPreventa?.errores.find(
                (e) =>
                  e ===
                  EstadoValidacionPreventaEnum.CODIGO_DACTILAR_NO_COINCIDEN
              )
            )
              return setAlert(
                true,
                "Ingresar codigo dactilar",
                AlertSeverityEnum.warning
              );

            if (
              codigoDactilar.length < 10 &&
              dataPreventa?.errores.find(
                (e) =>
                  e ===
                  EstadoValidacionPreventaEnum.CODIGO_DACTILAR_NO_COINCIDEN
              )
            )
              return setAlert(
                true,
                "Ingresar codigo dactilar de 10 digitos",
                AlertSeverityEnum.warning
              );

            if (imgIdentificacion) {
              const resp = await handleUpdateFile(
                imgIdentificacion!,
                BucketAwtENUM.IMAGE_CONTRATO,
                dataPreventa?.url_foto_identificacion_posterior!
              );
              if (!resp) return;
            }

            const resp = await mutateAsyncPreventa({
              id: dataPreventa?.id_preventa!,
              data: {
                url_foto_identificacion_posterior:
                  dataPreventa?.url_foto_identificacion_posterior!,
                codigo_dactilar: codigoDactilar
                  ? codigoDactilar
                  : dataPreventa?.cliente_data.codigo_dactilar!,
                estado_validacion: EstadoValidacionPreventaEnum.CORREJIDO,
              },
            });

            if (resp.code === 200) {
              setImgIdentificacion(null);
              setCodigoDactilar("");
              setOpenModal(false);
            }
          } catch (error) {
            setImgIdentificacion(null);
            setOpenModal(false);
            handleAxiosError(error);
          }
        }}
        contentNode={
          <Grid container>
            {dataPreventa?.errores.find(
              (e) =>
                e === EstadoValidacionPreventaEnum.FOTO_CEDULA_TRASERA_BORROSA
            ) && (
              <Grid container item xs={12} spacing={2}>
                <Grid item xs={12}>
                  <TabTextLabel
                    text={`${EstadoValidacionPreventaEnum.FOTO_CEDULA_TRASERA_BORROSA}`}
                    color="red"
                    mt={0}
                    pb={0}
                    pl={0}
                    pt={0}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    variant="subtitle2"
                    style={{
                      color: "#6C737F",
                    }}
                  >
                    {`La foto del reverso de la identificación está borrosa.`}
                  </Typography>
                </Grid>

                <Grid item {...gridSizeMdLg6}>
                  <Typography
                    variant="subtitle2"
                    style={{ margin: "0px 0px 20px 0px" }}
                  >
                    Documento
                  </Typography>
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={dataPreventa?.url_foto_identificacion_posterior}
                      style={{
                        height: "150px",
                      }}
                    ></img>
                  </div>
                </Grid>

                <Grid item {...gridSizeMdLg6}>
                  <ImageUploadComponente
                    buttonText={"Cargar identficacion trasera"}
                    selectedImage={imgIdentificacion}
                    setSelectedImage={setImgIdentificacion}
                    idInput={"identificacion-reverso-actualizar"}
                    imageUrl={""}
                  />
                </Grid>
              </Grid>
            )}

            {dataPreventa?.errores.find(
              (e) =>
                e === EstadoValidacionPreventaEnum.CODIGO_DACTILAR_NO_COINCIDEN
            ) && (
              <Grid item container {...gridSizeMdLg12} spacing={2}>
                <Grid item xs={12}>
                  <TabTextLabel
                    text={`${EstadoValidacionPreventaEnum.CODIGO_DACTILAR_NO_COINCIDEN}`}
                    color="red"
                    mt={0}
                    pb={0}
                    pl={0}
                    pt={0}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    variant="subtitle2"
                    style={{
                      color: "#6C737F",
                    }}
                  >
                    {`El código dactilar ingresado no coincide con el que aparece en la cédula.`}
                  </Typography>
                </Grid>

                <CustomTextFieldNoForm
                  label="Codigo Dactilar Ingresado"
                  value={dataPreventa?.cliente_data.codigo_dactilar || ""}
                  disabled
                  size={gridSizeMdLg6}
                />

                <Grid item {...gridSizeMdLg6}>
                  <TextField
                    label="Ingresar Codigo Dactilar"
                    variant="outlined"
                    value={codigoDactilar}
                    placeholder="Ej: A1B2C3D4E5"
                    fullWidth
                    inputProps={{ style: { textTransform: "uppercase" } }}
                    onChange={(event) => {
                      const uppercaseValue = event.target.value.toUpperCase();
                      if (uppercaseValue.length <= 10) {
                        setCodigoDactilar(uppercaseValue);
                      }
                    }}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        }
      />
    </>
  );
}
